import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { WatchlistManagerModal } from '@terminal/modules/watchlist-manager-modal/WatchlistManagerModal';
import { queryKeys } from '@terminal/routes/query-params';
import { SearchAssetWidget } from '@terminal/widgets/search-asset-widget/SearchAssetWidget';
import { useEffect, useState } from 'react';
import { WidgetPathNames, widgetPaths } from './widget-utils';

export const Widgets = () => {
  const { params } = useQueryParams();
  const [activeWidget, setActiveWidget] = useState<WidgetPathNames | null>();
  useEffect(() => {
    validateWidgetParams();
  }, [params]);

  const validateWidgetParams = () => {
    const widgetParam = params[queryKeys.widget] as WidgetPathNames | null;
    setActiveWidget(widgetParam);
  };

  const widgetViews = {
    [widgetPaths.searchAsset]: {
      component: <SearchAssetWidget />,
    },
    [widgetPaths.watchlistManagerModal]: {
      component: <WatchlistManagerModal />,
    },
    [widgetPaths.editWatchlistModal]: {
      component: <WatchlistManagerModal isEditMode />,
    },
  };

  if (!activeWidget || !widgetViews[activeWidget]?.component) {
    return null;
  }

  return <div>{widgetViews[activeWidget].component}</div>;
};
